import React from 'react';
import HARDCODED_TOGGLES from './featureTogglesData';

/**
 * Read supplied list of feature toggles from Optimizely service and local storage (FeatureToggleContext)
 * and pass it down to children components via props
 *
 * @param {Object} toggleMap - feature toggle names
 * @param {Boolean} withToggleVariables - read and pass all toggle variables to component
 * @returns {Function}
 */
export const withFeatureToggles =
  (toggleMap, withToggleVariables = false) =>
  (Component) => {
    const TogglesConsumer = (props) => {
      const featureProps = HARDCODED_TOGGLES;
      const newProps = Object.assign({}, props, withToggleVariables ? { features: featureProps } : featureProps);

      return <Component {...newProps} />;
    };

    TogglesConsumer.displayName = `TogglesConsumer(${Component.displayName || Component.name})`;

    return TogglesConsumer;
  };

export default withFeatureToggles;
